import axiosInstance from '../helpers/axios';
import { handleError, handleSuccess, waitAndReload } from '../helpers/utils';
import { types } from '../types/types';
import { getToken } from './auth';

// Dispatch set providers
export const setProviders = (data) => ({
	type: types.setProviders,
	payload: data,
});

// Dispatch clean providers
export const cleanProviders = () => ({
	type: types.cleanProviders,
});

// Register provider
export const registerProvider = async (data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/client/provider/',
		headers: { Authorization: 'Bearer ' + token },
		data: data,
	});
};

// Update provider
export const updateProvider = async (id, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/client/provider/${id}`,
		headers: { Authorization: 'Bearer ' + token },
		data: data,
	});
};

// Get provider info
export const getProviderInfo = async (id) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/client/provider/${id}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get all providers
export const getProviders = async (endpoint = null, pageSize = 10) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: endpoint
			? endpoint
			: `/api/client/provider/?ordering=-created_at&page_size=${pageSize}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Delete provider
export const deleteProvider = (id) => {
	return () => {
		// Get token if authenticated
		const token = getToken();
		axiosInstance({
			method: 'delete',
			url: `/api/client/provider/${id}`,
			headers: { Authorization: 'Bearer ' + token },
		})
			.then(() => {
				handleSuccess('Proveedor eliminado correctamente.');
				waitAndReload();
			})
			.catch((error) => {
				handleError(error, 'No se pudo eliminar al Proveedor.');
			});
	};
};
